module.exports = __webpack_public_path__ + "static/media/hls-adaptive-bitrate-icon.1f86341c.svg";